import { GridBtnsOptions } from './grid-btns-options.enum';

/**
 * Represents a change in disability for a button.
 */
export class GridBtnsDisable {
  constructor(public btn: GridBtnsOptions, public disabled: boolean) {}
}
